export default __webpack_public_path__ + "static/media/separator.bf33573a.svg";